import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { products } from '../data/products';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = products.find(p => p.id === parseInt(id));
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  if (!product) {
    return (
      <div className="product-not-found">
        <div className="container">
          <h2>Product Not Found</h2>
          <p>Sorry, we couldn't find the product you're looking for.</p>
          <Link to="/products" className="btn btn-primary">Back to Products</Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    alert(`Added ${quantity} x ${product.name} to cart!`);
  };

  return (
    <div className="product-detail-page">
      <div className="container">
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <Link to="/products">Products</Link> / {product.name}
        </div>

        <div className="product-detail-content">
          <div className="product-images">
            <div className="main-image">
              <img src={product.images[selectedImage]} alt={product.name} />
            </div>
            <div className="image-thumbnails">
              {product.images.map((image, index) => (
                <div
                  key={index}
                  className={`thumbnail ${selectedImage === index ? 'active' : ''}`}
                  onClick={() => setSelectedImage(index)}
                >
                  <img src={image} alt={`${product.name} ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          <div className="product-info-detail">
            <h1>{product.name}</h1>
            <p className="product-short-desc">{product.shortDescription}</p>
            <div className="product-price-large">{product.price}</div>

            <div className="product-dosage-info">
              <h4>Available Dosages</h4>
              <p>{product.dosage}</p>
            </div>

            <div className="product-quantity">
              <label>Quantity:</label>
              <div className="quantity-selector">
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))} disabled>-</button>
                <input type="number" value={quantity} onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value) || 1))} disabled />
                <button onClick={() => setQuantity(quantity + 1)} disabled>+</button>
              </div>
            </div>

            <div className="sold-out-notice">
              Currently Sold Out
            </div>

            <div className="product-actions">
              <button className="btn btn-primary btn-large" onClick={handleAddToCart} disabled>
                Add to Cart
              </button>
              <button className="btn btn-secondary" onClick={() => navigate('/products')}>
                Back to Products
              </button>
            </div>
          </div>
        </div>

        <div className="product-details-sections">
          <div className="detail-section">
            <h2>Description</h2>
            <p>{product.description}</p>
          </div>

          <div className="detail-section">
            <h2>Key Benefits</h2>
            <ul className="benefits-list">
              {product.benefits.map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
          </div>

          <div className="detail-section">
            <h2>Ingredients</h2>
            <p>{product.ingredients}</p>
          </div>

          <div className="detail-section">
            <h2>Suggested Use</h2>
            <p>{product.usage}</p>
          </div>

          <div className="detail-section disclaimer">
            <h4>Important Information</h4>
            <p className="small-text">
              These statements have not been evaluated by the Food and Drug Administration.
              This product is not intended to diagnose, treat, cure, or prevent any disease.
              Consult your healthcare provider before use if you are pregnant, nursing, taking
              medication, or have a medical condition.
            </p>
          </div>
        </div>

        <div className="related-products">
          <h2>You Might Also Like</h2>
          <div className="related-grid">
            {products
              .filter(p => p.id !== product.id)
              .slice(0, 3)
              .map(relatedProduct => (
                <Link
                  key={relatedProduct.id}
                  to={`/products/${relatedProduct.id}`}
                  className="related-product-card"
                >
                  <img src={relatedProduct.image} alt={relatedProduct.name} />
                  <h4>{relatedProduct.name}</h4>
                  <p className="related-price">{relatedProduct.price}</p>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
